import React, { useState, useEffect } from 'react';
import { Bar } from 'react-chartjs-2';
import { Chart } from 'chart.js';
import ChartDataLabels from 'chartjs-plugin-datalabels';
import moment from 'moment';
import { connect } from 'react-redux';
import styles from './DealStatusChart.module.scss';
import { Grid } from '@material-ui/core';
import {
	KeyboardArrowUp,
	KeyboardArrowDown,
	StopRounded,
} from '@material-ui/icons';
import ImgGrayBarChart from '../../../../assets/icons/ImgGrayBarChart.svg';
import { getPurchasers } from '../../../../redux/purchasers/actions';
import getContractStatus from '../../../../api/Purchasers/getContractStatus.api';
import {
	setDealStatusFilterBy,
	clearDealStatusFilterBy,
} from '../../../../redux/deals/action';

const colorDefault = [
	'#438afe', //  buyer
	'#29be67', // firmDeal
	'#ff9e00', // builder
	'#e0e0e0', // incomplete
	'#855CF8', // coolingPeriod
	'#f50057', // admin
];
const labelDefault = [
	'Buyer',
	'Firm Deal',
	'Builder',
	'Incomplete',
	//@TODO: If you want cooling period, use this
	// 'Cooling Period',
	'Admin',
	'Cancelled',
];

const DealStatusChart = (props) => {
	Chart.register(ChartDataLabels);
	const {
		salesAgentId,
		filterByDate,
		purchaserList,
		agreements,
		getPurchasers,
		setDealStatusFilterBy,
		clearDealStatusFilterBy,
	} = props;
	const [apsStatusArr, setApsStatusArr] = useState([]);
	const [apsStatusNumber, setApsStatusNumber] = useState({});
	const [checkIfEmpty, setCheckIfEmpty] = useState(false);
	const [referToggle, setReferTogge] = useState(false);
	const [contractStatus, setContractStatus] = useState([]);
	const [dataset, setDatset] = useState([]);
	const [newLabels, setNewLabels] = useState([]);
	const [chartPalette, setChartPalette] = useState([]);
	const [totalPercentage, setTotalPercentage] = useState('XX');

	//@TODO:
	//1, Use use effect to get the getOutForSignatureStatuses from redux
	// Write api to get purchaser from specific user for filter purposes.
	//2, To get the params (purchaser list), call getPurchasers from redux purchasers (purchaserList)
	//3. Manipulate returned JSON object to get the missing statuses.
	//4. Group json by value status
	//4 Change the statuses.
	useEffect(() => {
		// console.log('purchaserListpurchaserList', purchaserList);
		//getPurchasers();
	}, []);

	useEffect(() => {
		let contractStatusArr = [];
		if (purchaserList) {
			Object.keys(purchaserList).length !== 0 &&
				purchaserList.forEach((purchaser) => {
					let leadParam = purchaser?.leadId;
					let salesParam = purchaser?.leadToSalesAgent;
					let parameter = {
						leadId: leadParam,
						salesAgentId: salesParam,
					};
					leadParam &&
						getContractStatus(parameter, (returned) => {
							contractStatusArr.push(returned);
							setContractStatus(contractStatusArr);
						});
				});
		}
	}, [purchaserList, agreements]);
	useEffect(() => {
		if (salesAgentId && salesAgentId !== 'allSalesAgents') {
			setApsStatusArr(
				contractStatus
					.filter(
						(contract) => contract?.salesAgentId === salesAgentId
					)
					.filter((contract) => {
						let timestamp = contract?.timestamp;
						if (filterByDate === 'All' && timestamp) {
							return true;
						} else if (filterByDate === 'Month' && timestamp) {
							return moment(timestamp).isBetween(
								moment().subtract(1, 'months'),
								moment()
							);
						} else if (filterByDate === 'Week' && timestamp) {
							return moment(timestamp).isBetween(
								moment().subtract(7, 'days'),
								moment()
							);
						} else if (filterByDate === 'Today' && timestamp) {
							return moment(timestamp).isBetween(
								moment().startOf('day'),
								moment()
							);
						} else {
							return true;
						}
					})
					.map((contract) => contract.name)
			);
		} else if (salesAgentId === 'allSalesAgents') {
			setApsStatusArr(
				contractStatus
					.filter((contract) => {
						let timestamp = contract?.timestamp;
						if (filterByDate === 'All') {
							return true;
						} else if (filterByDate === 'Month') {
							return moment(timestamp).isBetween(
								moment().subtract(1, 'months'),
								moment()
							);
						} else if (filterByDate === 'Week') {
							return moment(timestamp).isBetween(
								moment().subtract(7, 'days'),
								moment()
							);
						} else if (filterByDate === 'Today') {
							return moment(timestamp).isBetween(
								moment().startOf('day'),
								moment()
							);
						} else {
							return true;
						}
					})
					.map((contract) => contract.name)
			);
		}
		console.log('second use effect', contractStatus);
	}, [contractStatus, salesAgentId, filterByDate]);

	useEffect(() => {
		if (apsStatusArr && apsStatusArr.length > 0) {
			setCheckIfEmpty(false);
			setApsStatusNumber({
				buyer: apsStatusArr.filter((status) => status === 'Buyer')
					.length,
				firmDeal: apsStatusArr.filter(
					(status) => status === 'Firm Deal'
				).length,
				builder: apsStatusArr.filter((status) => status === 'Builder')
					.length,
				incomplete: apsStatusArr.filter(
					(status) => status === 'Incomplete'
				).length,

				//@TODO: If you want cooling period, use this
				// coolingPeriod: apsStatusArr.filter(
				// 	(status) => status === 'Cooling Period'
				// ).length,
				admin: apsStatusArr.filter((status) => status === 'Admin')
					.length,
				cancelled: apsStatusArr.filter(
					(status) => status === 'Cancelled'
				).length,
			});
		} else {
			setCheckIfEmpty(true);
		}
		console.log('third use effect', apsStatusArr);
	}, [apsStatusArr]);
	useEffect(() => {
		let newDataArr = [];
		let newLabelArr = [];
		let newPalette = [];
		let total = 0;
		let divided = 0;
		for (const key in apsStatusNumber) {
			if (apsStatusNumber[key] !== 0) {
				newDataArr.push(apsStatusNumber[key]);
				total += parseInt(apsStatusNumber[key]);
				// set total (incomplete+firmDeal+builder+coolingPeriod)/total*100
				switch (key) {
					case 'buyer':
						newLabelArr.push(labelDefault[0]);
						newPalette.push(colorDefault[0]);
						break;
					case 'firmDeal':
						newLabelArr.push(labelDefault[1]);
						newPalette.push(colorDefault[1]);
						divided += parseInt(apsStatusNumber[key]);
						break;
					case 'builder':
						newLabelArr.push(labelDefault[2]);
						newPalette.push(colorDefault[2]);
						divided += parseInt(apsStatusNumber[key]);
						break;
					case 'incomplete':
						newLabelArr.push(labelDefault[3]);
						newPalette.push(colorDefault[3]);
						divided += parseInt(apsStatusNumber[key]);
						break;
					//@TODO: If you want cooling period, use this
					// case 'coolingPeriod':
					// 	newLabelArr.push(labelDefault[4]);
					// 	newPalette.push(colorDefault[4]);
					// 	divided += parseInt(apsStatusNumber[key]);
					// 	break;
					case 'admin':
						newLabelArr.push(labelDefault[4]);
						newPalette.push(colorDefault[4]);
						break;
					case 'cancelled':
						newLabelArr.push(labelDefault[5]);
						newPalette.push(colorDefault[5]);
						break;
				}
			}
		}
		let emptyArrLabel = new Array(6 - newLabelArr.length).fill('');
		let combiedLabels = newLabelArr.concat(emptyArrLabel);

		console.log('newDataArr', combiedLabels);
		setDatset(newDataArr);
		setNewLabels(combiedLabels);
		setChartPalette(newPalette);
		setTotalPercentage(total);
		console.log('forth use effect', newDataArr);
	}, [apsStatusNumber]);
	useEffect(() => {
		return () => {
			clearDealStatusFilterBy();
		};
	}, []);
	const data = {
		labels: newLabels,
		datasets: [
			{
				barPercentage: 1,
				categoryPercentage: 1,
				data: dataset,
				backgroundColor: chartPalette,
				borderWidth: 1,
				datalabels: {
					// styling for element data on chart
					display: true,
					align: 'end',
					anchor: 'start',
					color: '#fff',
					font: {
						size: 16,
						weight: 500,
					},
				},
			},
		],
	};

	const barClickEvent = (event, array) => {
		setDealStatusFilterBy(newLabels[array[0]?.index]);
	};

	const options = {
		indexAxis: 'y',
		scales: {
			x: {
				display: false, // Hide  x axis label
			},
			y: {
				ticks: { display: false }, // Hide  y axis label, but display grid line
				display: false, // Hide chart guide line
			},
		},
		plugins: {
			legend: {
				display: false,
			},
			tooltip: {
				enabled: true,
				callbacks: {
					label: (context) => {
						let sum = context.dataset.data.reduce(
							(acc, cur) => acc + cur
						);
						return (
							newLabels[context.dataIndex] +
							` (${context.dataset.data[context.dataIndex]}) ${(
								(context.dataset.data[context.dataIndex] /
									sum) *
								100
							).toFixed(2)}%`
						);
					},
				},
			},
		},
		hoverBorderColor: 'var(--text-mid-emphasis)',
		onClick: barClickEvent,
		animation: false,
	};
	return (
		<div className={styles.deal_status_chart}>
			{checkIfEmpty === false ? (
				<>
					<Bar options={options} data={data} />

					<div className={styles.totals_wrapper}>
						<span className={styles.total_text}>Total</span>
						<span className={styles.number_text}>
							{totalPercentage}
						</span>
					</div>
					<div
						className={styles.toggle_reference}
						onClick={() => setReferTogge(!referToggle)}
					>
						<span>References</span>
						{referToggle ? (
							<KeyboardArrowUp />
						) : (
							<KeyboardArrowDown />
						)}
					</div>
				</>
			) : (
				<div className={styles.nodeals_wrapper}>
					<img src={ImgGrayBarChart} alt='no data status' />
					<span>No deal status available</span>
				</div>
			)}

			{checkIfEmpty === false && (
				<div className={referToggle ? styles.show : styles.none}>
					<Grid container className={styles.references_wrapper}>
						{Object.keys(apsStatusNumber).map(function (
							key,
							index
						) {
							return (
								<Grid item xs={6} key={key}>
									<div className={styles.reference_label}>
										<StopRounded
											className={styles.color_icon}
											style={{
												color: colorDefault[index],
											}}
										/>
										<span>
											{labelDefault[index]} (
											{apsStatusNumber[key]})
										</span>
									</div>
								</Grid>
							);
						})}
					</Grid>
				</div>
			)}
		</div>
	);
};

const mapStateToProps = (state) => ({
	purchaserList: state.purchasers.purchaserList,
	agreements: state.purchasers?.agreements,
});

export default connect(mapStateToProps, {
	getPurchasers,
	setDealStatusFilterBy,
	clearDealStatusFilterBy,
})(DealStatusChart);
